export const TIDS = {
  nav: {
    home: "nav-home",
    about: "nav-about",
    work: "nav-work",
    testimonials: "nav-testimonials",
    contact: "nav-contact",
    cta: "nav-cta",
    logo: "nav-logo",
    mobileToggle: "nav-mobile-toggle",
  },
  hero: {
    ctaPrimary: "hero-cta-primary",
    ctaSecondary: "hero-cta-secondary",
  },
  contact: {
    name: "contact-form-name",
    email: "contact-form-email",
    brand: "contact-form-brand",
    budget: "contact-form-budget",
    message: "contact-form-message",
    submit: "contact-form-submit",
    success: "contact-form-success",
  },
  card: (slug) => `case-study-card-${slug}`,
  testimonial: (i) => `testimonial-card-${i}`,
};
